module.exports = require("./fr-NC.d.ts");